module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/standard-roof-minibus.7fba481d.svg";